import { Directive, Input, ElementRef, TemplateRef, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { UsersService } from 'src/app/services/users-service/users.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { USERROLES } from 'src/app/models/CONSTANTS';

@Directive({
  selector: '[appUserRole]'
})
export class UserRoleDirective implements OnInit, OnDestroy {

  private currUserRoles: USERROLES[] = [];
  private neededRoles: USERROLES[] = [];
  private userSubscription: Subscription;
  private operator: 'OR' | 'AND' = 'OR';
  constructor(private element: ElementRef, private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private usersService: UsersService) { }

  ngOnInit() {
    this.userSubscription = this.usersService.currentUser$.pipe(filter( user => user != null)).subscribe( user => {
      this.currUserRoles = user.roles;
      this.updateView();
    });
  }

  @Input()
  set appUserRole(roles: USERROLES[]) {
    this.neededRoles = roles;
    this.updateView();
  }

  @Input()
  set roleOperator(op: 'OR' | 'AND') {
    this.operator = op;
  }

  checkIfPermission(): boolean {
    if (this.operator === 'OR') {
      for (const userRole of this.currUserRoles) {
        if (this.neededRoles.find(nRole => nRole.toUpperCase() === userRole.toUpperCase())) {
          return true;
        }
      }
    } else {
      for (const userRole of this.currUserRoles) {
        if (this.neededRoles.find(nRole => nRole.toUpperCase() === userRole.toUpperCase()) == null) {
          return false;
        }
      }
      return true;
    }
    return false;
  }

  private updateView() {
    if (this.checkIfPermission()) {
      if (this.viewContainer.length < 1) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    } else {
      this.viewContainer.clear();
    }
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
  }
}